exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/**\nEssential imports for the global theme, but also to be used in single components\n**/\n.search-bar {\n  background: #edeef0;\n}\n.search-bar .card {\n  background: #edeef0;\n}\n.search-bar .btn-close {\n  background: none;\n  border: none;\n}\n.search-bar .white-space {\n  margin-top: 0;\n  border-top: 4px solid #ffffff;\n}\n.search-bar .break-word {\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}", ""]);

// exports
